import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/exam/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },

  async list(options?: ApiSchemas['ListExamDto']) {
    return wrapEndpoint(() =>
      client.GET('/exam', {
        params: {
          query: options,
        },
      }),
    )
  },

  async create(dto: ApiSchemas['CreateExamDto']) {
    return wrapEndpoint(() =>
      client.POST('/exam', {
        body: dto,
      }),
    )
  },

  async update(id: number, dto: ApiSchemas['UpdateExamDto']) {
    return wrapEndpoint(() =>
      client.PUT('/exam/{id}', {
        body: dto,
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },

  async delete(id: number) {
    await wrapEndpoint(() =>
      client.DELETE('/exam/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
